import React, { useState, useEffect } from "react";
import api from "../api/api";
import { toast } from "react-toastify";
import "./AdminSlider.scss";
import { image_base_url } from "../api/api";

function AdminSlider() {

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  const [displayOrder, setDisplayOrder] = useState("");
  const [sliders, setSliders] = useState([]);

  //const IMAGE_BASE = "http://localhost:5170";

  useEffect(() => {
    loadSliders();
  }, []);

  const loadSliders = async () => {
    const res = await api.get("/slider");
    setSliders(res.data);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);

    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("image", image);
    formData.append("displayOrder", displayOrder);

    await api.post("/slider", formData);

    toast.success("Slider Uploaded ✅");

    setImage(null);
    setPreview("");
    setDisplayOrder("");

    loadSliders();
  };

  const deleteSlider = async (id) => {
    await api.delete(`/slider/${id}`);
    toast.success("Slider Deleted");
    loadSliders();
  };

  return (
    <div className="admin-slider-page">

      <h4 className="page-title border-bottom border-2 pb-3">Homepage Slider Manager</h4>

      {/* Upload Card */}

      <div className="upload-card">

        <h5>Add New Slider</h5>

        <form onSubmit={handleSubmit}>

          <div className="image-upload-box">

            {preview ? (
              <img src={preview} alt="preview" />
            ) : (
              <label className="upload-label">
                Upload Slider Image
              </label>
            )}

            <input
              type="file"
              onChange={handleImageChange}
              required
            />

          </div>

          <input
            type="number"
            placeholder="Display Order"
            value={displayOrder}
            onChange={(e) => setDisplayOrder(e.target.value)}
            className="form-control order-input"
            required
          />

          <button className="btn upload-btn">
            Upload Slider
          </button>

        </form>

      </div>

      {/* Slider List */}

      <h5 className="slider-list-title">All Sliders</h5>

      <div className="slider-grid">

        {sliders.map((s) => (

          <div className="slider-card" key={s.sliderId}>

            <img
              src={image_base_url + s.imageUrl}
              alt=""
            />

            <div className="slider-info">

              <span>Order: {s.displayOrder}</span>

              <button
                className="delete-btn"
                onClick={() => deleteSlider(s.sliderId)}
              >
                Delete
              </button>

            </div>

          </div>

        ))}

      </div>

    </div>
  );
}

export default AdminSlider;